import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthorizeService } from '../../shared/services/authorize.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authorizeService = inject(AuthorizeService);
  const router = inject(Router);
  const token = authorizeService.getAccessToken();

  const shouldAddAuth = [
    environment.apiMojito,
    environment.apiGreen,
    environment.apiOdata,
    'token',
  ].some((url) => req.url.includes(url));

  const authRequest = shouldAddAuth
    ? req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token),
      })
    : req;

  return next(authRequest).pipe(
    tap({
      error: (error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          router.navigate(['/account/login'], {
            queryParams: { redirect: router.url },
            replaceUrl: true,
          });
        }
      },
    })
  );
};
